module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AkbCSEk79XJcAAAAK5JREFUOMtjYBgFFANmXBLC0jJMUkJCawX5+b++//jxFi51TLgkBJiZNv3/z2D6////zYry8k4kGaAorzCLgZHJnOUPkx4TE1M0EwPjXmV5BQei/KQor7BUWV7hjbysnDhMTElOMUpJXuG/spyiFV7NynLylcryCp+V5OU0MAyWlStWllf4rywvb4jTC/8ZGWT///9neO/hoxvoBtx//KiXkYEh6f9/BoXRtEdlAAD7GinpqxpL6wAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowup.png
 ** module id = 196
 ** module chunks = 0 1
 **/